import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {DadProduct, DadProductPrice} from '../models/models';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class DadProductService {

  constructor(private httpClient: HttpClient) {
  }

  createDadProduct(dadProduct: DadProduct): Observable<any> {
    return this.httpClient.post<any>(environment.baseUrlWs + '/api/dad-product', dadProduct);
  }

  editDadProduct(product: DadProduct): Observable<any> {
    const newProductInfos = {
      productCode: product.productCode,
      productType: product.productType,
      startDate: product.startDate
    };
    return this.httpClient.put<any>(environment.baseUrlWs + '/api/dad-product/' + product.id, newProductInfos);
  }

  deleteDadProduct(dadProductId: number): Observable<any> {
    return this.httpClient.delete<any>(environment.baseUrlWs + '/api/dad-product/' + dadProductId);
  }

  deleteDadProductPrice(dadProductPrice: DadProductPrice): Observable<any> {
    return this.httpClient.delete<any>(environment.baseUrlWs + '/api/dad-product-price/' + dadProductPrice.id);
  }

}
